import React, { useEffect, useState } from 'react';
// Import your icon images here
import whatsappIcon from '../../assets/whatsapp-button.svg';
import emailIcon from '../../assets/mail.svg';
import phoneIcon from '../../assets/telephone-button.svg';

const Widget = () => {
  const [isActive, setIsActive] = useState(false);

  const toggleActive = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    if (isActive) {
      // document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isActive]);

  return (
    <>
      <style jsx>{``}</style>

      <div className={`fabWidget ${isActive ? 'active' : ''}`}>
        <div
          className='fabTrigger'
          onClick={toggleActive}
        >
          <div className='background'></div>
          <svg
            className='chat-bubble'
            width='80'
            height='80'
            viewBox='0 0 100 100'
          >
            <g className='bubble'>
              <path
                className='line line1'
                d='M 30.7873,85.113394 30.7873,46.556405 C 30.7873,41.101961 36.826342,35.342 40.898074,35.342 H 59.113981 C 63.73287,35.342 69.29995,40.103201 69.29995,46.784744'
              />
              <path
                className='line line2'
                d='M 13.461999,65.039335 H 58.028684 C 63.483128,65.039335 69.243089,59.000293 69.243089,54.928561 V 45.605853 C 69.243089,40.986964 65.02087,35.419884 58.339327,35.419884'
              />
            </g>
            <circle
              className='circle circle1'
              r='1.9'
              cy='50.7'
              cx='42.5'
            />
            <circle
              className='circle circle2'
              cx='49.9'
              cy='50.7'
              r='1.9'
            />
            <circle
              className='circle circle3'
              r='1.9'
              cy='50.7'
              cx='57.3'
            />
          </svg>
        </div>
        <div className='fabList'>
          <a
            className='fabButton'
            href='https://wa.me/919429620999'
            data-tooltip='WhatsApp'
          >
            <img
              src={whatsappIcon}
              alt='WhatsApp'
              style={{ width: '33px', height: '33px' }}
            />
          </a>
          <a
            className='fabButton'
            href='mailto:info@bluelagoontravels.com'
            data-tooltip='Email'
          >
            <img
              src={emailIcon}
              alt='Email'
              style={{ width: '30px', height: '30px' }}
            />
          </a>
          <a
            className='fabButton'
            href='tel:+917573035965'
            data-tooltip='Phone'
          >
            <img
              src={phoneIcon}
              alt='Phone'
              style={{ width: '28px', height: '28px' }}
            />
          </a>
        </div>
      </div>
      <div
        className={`fabOverlay ${isActive ? 'active' : ''}`}
        onClick={toggleActive}
      ></div>
    </>
  );
};

export default Widget;
